import { Fragment, useEffect, useState } from 'react';
import { Header, Icon, Label, Message, Table } from 'semantic-ui-react';
import ConfirmationModal from '../../../../../components/confirmationModal';
import { RESPONSE_STATUS } from '../../../../../constnats/general';
import useFullModalState from '../../../../../hooks/useFullModalState';
import { CONFIRM_DELETE_STANDARDIZED_LABEL } from '../../../../../messages';
import {
    StandardizedLabelCreationSchemaType,
    StandardizedLabelIdType,
    StandardizedLabelType,
    StandardizedLabelUpdateSchemaType,
} from '../../../../../schemas/standardizedLabel.schemas';
import Alert from '../../../../../utils/alert';
import StandardizedLabelsRepo from '../../../../../utils/repository/standardizedLabelsRepo/standardizedLabelsRepo';
import StandardizedLabelModal from '../standardizedLabelModal';
import Loader from '../../../../../components/loader';
import StandardizedLabelRow from './components/standardizedLabelRow';

function StandardizedLabels() {
    const standardizedLabelModal = useFullModalState<StandardizedLabelType | undefined>();
    const deleteModalState = useFullModalState<StandardizedLabelType>();
    const [standardizedLabels, setStandardizedLabels] = useState<StandardizedLabelType[]>([]);
    const [loading, setLoading] = useState(false);
    const loadStandardizedLabels = () => {
        setLoading(true);
        StandardizedLabelsRepo.listStandardizedLabels(
            (response) => {
                if (response.status === RESPONSE_STATUS.SUCCESS) {
                    setStandardizedLabels(response.data.sort((a, b) => a.name.localeCompare(b.name)));
                    setLoading(false);
                } else {
                    Alert.warn(response.message);
                }
            },
            (error) => Alert.warn(JSON.stringify(error)),
        );
    };

    const createStandardizedLabel = (creationSpecs: StandardizedLabelCreationSchemaType) => {
        StandardizedLabelsRepo.createStandardizedLabel(
            creationSpecs,
            (response) => {
                if (response.status === RESPONSE_STATUS.SUCCESS) {
                    Alert.success('Creation successful!');
                    standardizedLabelModal.closeModal();
                    loadStandardizedLabels();
                } else {
                    Alert.warn(response.message);
                }
            },
            (error) => Alert.warn(JSON.stringify(error)),
        );
    };

    const updateStandardizedLabel = (standardizedLabelId: StandardizedLabelIdType, updateSpecs: StandardizedLabelUpdateSchemaType) => {
        StandardizedLabelsRepo.updateStandardizedLabel(
            standardizedLabelId,
            updateSpecs,
            (response) => {
                if (response.status === RESPONSE_STATUS.SUCCESS) {
                    Alert.success('Creation successful!');
                    standardizedLabelModal.closeModal();
                    loadStandardizedLabels();
                } else {
                    Alert.warn(response.message);
                }
            },
            (error) => Alert.warn(JSON.stringify(error)),
        );
    };

    const deleteStandardizedLabel = (standardizedLabel: StandardizedLabelType) => {
        StandardizedLabelsRepo.deleteStandardizedLabel(
            standardizedLabel.id,
            (response) => {
                if (response.status === RESPONSE_STATUS.SUCCESS) {
                    Alert.success('Deletion successful!');
                    deleteModalState.closeModal();
                    loadStandardizedLabels();
                } else {
                    Alert.warn(response.message);
                }
            },
            (error) => Alert.warn(JSON.stringify(error)),
        );
    };

    useEffect(() => {
        loadStandardizedLabels();
    }, []);

    return (
        <div>
            <Header as="h2" textAlign="center">
                Standardized Labels
                <Label onClick={() => standardizedLabelModal.openModal(undefined)} className="cursorPointer">
                    <Icon name="add" />
                    Add
                </Label>
            </Header>
            {loading ? (
                <Loader />
            ) : (
                <Fragment>
                    {standardizedLabels.length ? (
                        <Table striped>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell>Id</Table.HeaderCell>
                                    <Table.HeaderCell>Name</Table.HeaderCell>
                                    <Table.HeaderCell>Scope</Table.HeaderCell>
                                    <Table.HeaderCell>Created On</Table.HeaderCell>
                                    <Table.HeaderCell>Updated On</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {standardizedLabels.map((a) => (
                                    <StandardizedLabelRow
                                        key={a.id}
                                        standardizedLabel={a}
                                        onEdit={standardizedLabelModal.openModal}
                                        onDelete={deleteModalState.openModal}
                                    />
                                ))}
                            </Table.Body>
                        </Table>
                    ) : (
                        <Message>No standardized labels to show</Message>
                    )}
                </Fragment>
            )}

            <StandardizedLabelModal
                open={standardizedLabelModal.open}
                standardizedLabel={standardizedLabelModal.modalData}
                onCancel={standardizedLabelModal.closeModal}
                onSave={(data) => {
                    if (standardizedLabelModal.modalData) {
                        updateStandardizedLabel(standardizedLabelModal.modalData.id, data);
                    } else {
                        createStandardizedLabel(data);
                    }
                }}
            />
            <ConfirmationModal
                open={deleteModalState.open}
                msg={CONFIRM_DELETE_STANDARDIZED_LABEL}
                onCancel={deleteModalState.closeModal}
                onConfirm={() => deleteStandardizedLabel(deleteModalState.modalData!)}
            />
        </div>
    );
}

export default StandardizedLabels;
